export default __webpack_public_path__ + "static/media/brigitte-ult.5526abc8.mp3";